import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for chart */
//   data: [],
//   /* Set additional options for area chart. */
//   options: {},
//   /* Theme of the area chart. */
//   theme: string,
// };

export default function Area(props) {
  const { className, data, options, ...otherProps } = props;

  const defaultOptions = {
    plotOptions: {
      area: {
        pointPadding: 0.2,
        borderWidth: 0,
        fillOpacity: 0.25,
      },
    },
  };

  return (
    <BaseChart
      className={className}
      chartType="area"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      {...otherProps}
    />
  );
}
